import { apiUrl, axiosAdminAuthInstanceLocal } from "../axiosInstance";

export const getInterpreterAvailabilityLog = ({ id, ...payload }) => {
  return axiosAdminAuthInstanceLocal({
    method: "POST",
    url: `${apiUrl.GET_INTERPRETER_AVAILABILITY_LOG}/${id}`,
    data: JSON.stringify(payload)
  });
};
